import { useState, useEffect } from 'react';
import { FadeText } from 'components/CustomAnimations';
import OrbsContainer from 'components/LottieElements/OrbsContainer';
import { BREAKPOINTS } from 'constants/breakpoints';

export const ImpactRatings = ({ impactRatings }: { impactRatings: object }) => {
  const [caption, setCaption] = useState(
    'Click on a value above to learn more about each Impact Score rating.'
  );
  const [numDots, setNumDots] = useState(window.innerWidth <= BREAKPOINTS.DESKTOP ? 6 : 10);
  const [startNumber, setStartNumber] = useState(window.innerWidth <= BREAKPOINTS.DESKTOP ? 5 : 1);

  useEffect(() => {
    const handleResize = () => {
      const isMobile = window.innerWidth <= BREAKPOINTS.DESKTOP;
      setNumDots(isMobile ? 6 : 10);
      setStartNumber(isMobile ? 5 : 1);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const handleDotClick = (index: number) => {
    const score = startNumber + index;
    const isMobile = window.innerWidth <= BREAKPOINTS.DESKTOP;

    if (isMobile && score === 5) {
      setCaption(impactRatings['5Mobile']);
    } else {
      setCaption(
        impactRatings[score] ||
          'Click on a value above to learn more about each Impact Score rating.'
      );
    }
  };

  return (
    <div className="impact-ratings-container">
      <div className="impact-ratings-title">
        <FadeText
          inViewTrigger
          delay={0.3}
          progressive
          className="h2-dtm"
          text="The higher the Impact Score, the greater the value of your donation in that race."
        />
      </div>
      <div className="impact-ratings-values">
        <OrbsContainer jsonType="impact_ratings_module">
          <div className="impact-ratings-dots">
            {Array.from({ length: numDots }).map((_, index) => (
              <div
                key={index}
                className="impact-ratings-dot-container"
                onClick={() => handleDotClick(index)}
              >
                <FadeText delay={0.2 * index} text={(startNumber + index).toFixed(1)} />
                <div className="impact-ratings-dot" />
              </div>
            ))}
          </div>
        </OrbsContainer>
      </div>
      <div className="impact-ratings-title">
        <FadeText inViewTrigger delay={0.5} className="body-text" text={caption} />
      </div>
    </div>
  );
};
